module.exports = __webpack_public_path__ + "img/二氧化碳.676b636e.png";